export interface CurrencyInfo {
  code: string;
  symbol: string;
}

export const getOrganizerCurrency = (): CurrencyInfo => {
  const defaultCurrency = { code: 'NZD', symbol: '$' };
  try {
    const orgDataStr = localStorage.getItem('organizerData');
    if (!orgDataStr) return defaultCurrency;
    const orgData = JSON.parse(orgDataStr);
    const countryId = String(orgData.countryId || '');
    switch (countryId) {
      case '6':
        return { code: 'INR', symbol: '₹' };
      case '7':
        return { code: 'NZD', symbol: '$' };
      case '393':
        return { code: 'GBP', symbol: '£' };
      case '394':
        return { code: 'AED', symbol: 'د.إ' };
      case '676':
        return { code: 'CHF', symbol: 'CHF' };
      default:
        return defaultCurrency;
    }
  } catch (error) {
    console.error('Error parsing organizerData for currency:', error);
    return defaultCurrency;
  }
};
